import routes from "../../constants/routes.json";

import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import { useModalStore } from "../../store/modalStore";
import { useAuthStore } from "../../store/authStore";
import { useNavigate } from "react-router-dom";

const UnauthorizedModal = () => {
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  const isModalOpen = useModalStore((state) => state.isModalOpen);
  const setModalOpen = useModalStore((state) => state.setModalOpen);

  const handleClose = () => {
    setModalOpen(false);
    logout();
    navigate(routes.LOGIN);
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "0.938rem",
          width: "28.125rem",
          height: "auto",
        },
        padding: 2,
      }}
    >
      <DialogTitle
        textAlign={"center"}
        variant="h4"
        fontWeight={600}
        color="red"
      >
        Unauthorized Access
      </DialogTitle>
      <DialogContent>
        <Typography textAlign={"center"} variant="body1">
          Your session has expired and you are not authorized to perform this
          action.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="error"
          onClick={handleClose}
          sx={{
            borderRadius: 3,
          }}
        >
          Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnauthorizedModal;
